import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'
import FormModal from '../Components/FormModal.js'

function Exams () {
  const pageName = 'exams'
  const pageTitle = 'İmtahanlar'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    editLink: rowData => `/${pageName}/${rowData.id}`,
    actions: {
      get: async (params = {}) => {
        const exams = await call.forLoggedUser.exam.getExams(params)
        if (exams.success) {
          return exams.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Tarix',
        property: ['date', 'time'],
        style: { width: '15%' },
        filter: {
          enabled: true,
          type: 'date',
          name: 'date'
        },
        mutate: values => {
          return use.convertDatetimeToShortDate(values[0]) + ' ' + values[1]
        }
      },

      {
        title: 'Filial',
        property: ['branchCode', 'branchName'],
        mutate: values => <span title={values[1]}>{values[0]}</span>,
        filter: {
          enabled: true,
          type: 'select',
          name: 'branchId',
          dataSource: async () => {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        style: { width: '10%' }
      },

      {
        title: 'Adı',
        property: 'name',
        style: { width: '20%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'name'
        }
      },
      {
        title: 'İmtahan növü',
        property: 'examTypeName',
        style: { width: '30%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'examTypeId'
        }
      },
      {
        title: 'İştirakçı',
        property: 'participantCount',
        style: { width: '5%' },
        filter: {
          enabled: false
        }
      },
      // {
      //   title: 'Orta nəticə',
      //   property: 'averageResult',
      //   style: { width: '10%' },
      //   filter: {
      //     enabled: false
      //   },
      //   mutate:(value)=>value
      // },
      {
        title: 'Status',
        property: ['statusId', 'statusName'],
        type: 'status-label',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'exam'
            })
            let data = source.data?.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: values => {
          return values[1]
        }
      },
      {
        title: 'Əməliyyat',
        property: ['id'],
        type: 'operations-list',
        operations: values => [
          {
            type: 'group',
            name: 'menu',
            title: 'Group',
            icon: '...',
            items: [
              {
                type: 'command',
                name: 'delete',
                title: 'Qeydi sil',
                warning: `İmtahana aid bütün məlumatlar, o cümlədən, \n - İştirak \n - Qiymətləndirmə \n məlumatları birdəfəlik silinəcək.`,
                parameters: JSON.stringify({ id: values[0], entity: 'exam' }),
                iconType: 'path',
                icon: '/Images/Icons/delete.png',
                disablingConditions: []
              }
            ]
          }
        ],
        style: { width: '5%', minWidth: '50px' }
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'exam',
      id: '',
      label: 'İmtahan',
      isStandAlone: true,
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.exam.getExamById({ id: id }),
        add: call.forLoggedUser.exam.addExam,
        edit: call.forLoggedUser.exam.updateExam
      },
      formLists: {
        ExamTypeList: async () => {
          const source = await call.forLoggedUser.examType.getExamTypes({})
          let data = source.data?.map(d => {
            return { value: d.id, text: d.name }
          })
          return data
        },
        BranchList: async () => {
          const source = await call.forLoggedUser.branch.getBranches({})
          let data = source?.data?.map(d => {
            return { value: d.id, text: d.name }
          })
          return data
        },
        GroupList: async (examId,examTypeId) => {
          const source = await call.forLoggedUser.exam.getGroups({examId:examId,examTypeId:examTypeId})
          let data = source?.data?.map(s => {
            return { value: s.id, text: s.name }
          })
          return data
        },
        StatusList: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'exam'
          })
          return source?.data?.map(d => {
            return { value: d.id, text: d.description }
          })
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'İmtahan növü',
          type: 'select',
          fieldName: 'examTypeId',
          data: 'ExamTypeList',
          defaultValue:'',
          defaultSelectOptions:[{value:'',text:'Seçin'}],
          validationRules: ['required'],
          col: { sm: 4 }
        },
        {
          label: 'İmtahanın adı',
          type: 'text',
          fieldName: 'name',
          col: { sm: 3 }
        },
        {
          label: 'Tarix',
          type: 'date',
          fieldName: 'date',
          validationRules: ['required'],
          defaultValue: new Date().toLocaleDateString('az-AZ'),
          mutate: value => {
            return value != null
              ? new Date(value).toLocaleDateString('az-AZ')
              : null
          },
          col: { sm: 2 }
        },
        {
          label: 'Saat',
          type: 'time',
          fieldName: 'time',
          validationRules: ['required'],
          col: { sm: 1 }
        },
        {
          label: 'Filial',
          type: 'select',
          fieldName: 'branchId',
          col: { sm: 2 },
          data: 'BranchList'
        },
        // {
        //   label: 'Qruplar',
        //   type: 'select-multiple',
        //   data: 'GroupList',
        //   col: { sm: 12 },
        //   fieldName: 'groups',
        //   requestParams: ['global:examTypeId']
        // },
        {
          label: 'Əlavə qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 12 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          col: { sm: 2 },
          defaultValue: 0,
          data: 'StatusList'
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    },
    {
      name: 'participants',
      id: '',
      label: 'İmtahan iştirakçıları',
      isStandAlone: false,
      isMain: false,
      formLists: {
        StatusList: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'examParticipant'
          })
          return source.data?.map(d => {
            return { value: d.id, text: d.description }
          })
        },
        ExamParticipationPool: async () => {
          const source = await call.forLoggedUser.exam.getParticipantPool({})
          return source.data?.map(d => {
            return {
              value: d.studentId,
              text: `${d.name} ${d.surname} (${d.description})`
            }
          })
        },
        ExamParticipants: async id => {
          const source = await call.forLoggedUser.exam.getParticipation({
            examId: id
          })
          return source.data?.participation?.map(d => {
            return {
              value: d.studentId,
              text: `${d.name} ${d.surname} (${d.description})`
            }
          })
        },
        ExamSubjects: async id => {
          const source = await call.forLoggedUser.exam.getSubjects({
            examId: id
          })

          return source.data?.map(d => {
            return { subjectId: d.id, subjectName: d.name }
          })
        }
      },
      actions: {
        get: id => call.forLoggedUser.exam.getParticipation({ examId: id }),
        edit: call.forLoggedUser.exam.editParticipation
      },
      fields: [
        { type: 'hidden', fieldName: 'examId', label: '' },
        {
          label: 'İmtahanın növü',
          fieldName: 'examTypeName',
          type: 'readonly-text',
          col: { sm: 4 }
        },
        {
          label: 'Tarix',
          fieldName: 'examDate',
          type: 'readonly-text',
          mutate: value => {
            return value ? use.convertDatetimeToShortDate(value) : '-'
          },
          col: { sm: 2 }
        },
        {
          label: 'Saat',
          fieldName: 'examTime',
          type: 'readonly-text',
          col: { sm: 3 }
        },
        {
          label: 'İştirakçılar',
          single: 'iştirakçı',
          type: 'input-group-row',
          fieldName: 'participation',
          addRowPermission: true,
          multipleRows: true,
          removeRowPermission: true,
          commands: [
            {
              type: 'command',
              name: 'duplicateParticipants',
              title: 'Digər imtahandan idxal et',
              iconType: 'path',
              icon: '/Images/Icons/copy.png',
              parameters: ['id'],
              disablingConditions: [
              ]
            },
            {
              type: 'command',
              name: 'duplicateParticipants',
              title: 'İştirakçıları kopyala',
              iconType: 'path',
              icon: '/Images/Icons/copy.png',
              parameters: ['id'],
              disablingConditions: [
                // {
                //   fieldName: 'statusId',
                //   checkCondition: value => ![0, 1].includes(value)
                // }
              ]
            }
          ],
          validationRules: [
            {
              type: 'unique',
              fields: ['studentId']
            }
            // {//example check constraint
            //   type:'check',
            //   fields:['id','studentId'],
            //   rule:(params)=>params.id>params.studentId
            // }
          ],
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            }
          ],
          rowFields: [
            {
              label: '',
              type: 'hidden',
              fieldName: 'id'
            },
            {
              label: '',
              type: 'hidden',
              fieldName: 'examId'
            },
            {
              label: 'İştirakçı',
              type: 'select',
              fieldName: 'studentId',
              validationRules: ['required'],
              columnWidth: '30%',
              parameters: ['line:id'],
              data: params =>
                params.id ? 'ExamParticipants' : 'ExamParticipationPool',
              disablingConditions: [
                {
                  fieldName: 'id',
                  checkCondition: value =>
                    ![null, undefined, ''].includes(value)
                }
              ]
            },
            {
              label: 'Nəticə',
              type: 'number',
              readonly: true,
              defaultValue: 0,
              fieldName: 'score',
              columnWidth: '10%',
              parameters: ['line:id'],
              details: {
                label: 'Fənlər üzrə nəticələr',
                fieldName: 'subjectResults',
                type: 'dictionary',
                data: params => (params.id ? 'subjectResults' : 'ExamSubjects'),
                settings: {
                  key: {
                    fieldName: 'subjectId',
                    title: 'Fənn',
                    labelField: 'subjectName',
                    width: '70%',
                    type: 'text'
                  },
                  value: {
                    fieldName: 'score',
                    title: 'Nəticə',
                    type: 'number',
                    width: '30%',
                    defaultValue: 0
                  }
                },
                aggregate: {
                  type: 'sum', //count
                  show: true,
                  title: 'Ümumi'
                }
              }
            },
            {
              label: 'Qeydlər',
              type: 'text',
              columnWidth: '30%',
              fieldName: 'notes'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              defaultValue: 0,
              columnWidth: '15%',
              data: 'StatusList'
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              operations: [
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType: 'path',
                  icon: '/Images/Icons/delete.png',
                  iconStyle: { filter: 'invert(1)' },
                  disablingConditions: [
                    {
                      fieldName: 'score',
                      checkCondition: value =>
                        ![undefined, null, '', 0].includes(value)
                    }
                  ]
                }
              ],
              columnWidth: '15%'
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    }
  ]

  const test = async () => {
    let data = await call.forLoggedUser.test({})
    console.log(data)
  }

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      {/* <h5 className='page-description'>Bu səhifə kursun təşkil etdiyi bütün təlimlərin göstərilməsi, əlavə olunması və düzəlişlərin aparılması üçündür.</h5> */}
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Exams
